import React from "react";

type BadgeStatus = "green" | "amber" | "red" | "blue" | "violet" | "cyan" | "default";

interface ColonyBadgeProps {
  status?: BadgeStatus;
  children: React.ReactNode;
  dot?: boolean;
  className?: string;
}

const statusColors: Record<BadgeStatus, { bg: string; text: string; dot: string }> = {
  green: {
    bg: "bg-[rgba(34,197,94,0.1)]",
    text: "text-colony-green",
    dot: "bg-colony-green",
  },
  amber: {
    bg: "bg-[rgba(245,158,11,0.1)]",
    text: "text-colony-amber",
    dot: "bg-colony-amber",
  },
  red: {
    bg: "bg-[rgba(239,68,68,0.1)]",
    text: "text-colony-red",
    dot: "bg-colony-red",
  },
  blue: {
    bg: "bg-[rgba(59,130,246,0.1)]",
    text: "text-colony-blue",
    dot: "bg-colony-blue",
  },
  violet: {
    bg: "bg-[rgba(139,92,246,0.1)]",
    text: "text-colony-violet",
    dot: "bg-colony-violet",
  },
  cyan: {
    bg: "bg-[rgba(6,182,212,0.1)]",
    text: "text-colony-cyan",
    dot: "bg-colony-cyan",
  },
  default: {
    bg: "bg-colony-surface-elevated",
    text: "text-colony-text-secondary",
    dot: "bg-colony-text-secondary",
  },
};

export function ColonyBadge({
  status = "default",
  children,
  dot = false,
  className = "",
}: ColonyBadgeProps) {
  const colors = statusColors[status];

  return (
    <span
      className={`inline-flex items-center gap-1.5 h-5 px-2 rounded-[4px] text-[11px] font-medium whitespace-nowrap select-none
        ${colors.bg} ${colors.text} ${className}
      `}
    >
      {dot && <span className={`w-1.5 h-1.5 rounded-full ${colors.dot}`} />}
      {children}
    </span>
  );
}

export function ColonyPill({
  status = "default",
  children,
  className = "",
}: Omit<ColonyBadgeProps, "dot">) {
  const colors = statusColors[status];

  return (
    <span
      className={`inline-flex items-center gap-1.5 h-5 px-2.5 rounded-full text-[11px] font-medium whitespace-nowrap select-none
        ${colors.bg} ${colors.text} ${className}
      `}
    >
      {children}
    </span>
  );
}
